import { useCallback, useMemo, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { CARRIED_OFFER_STORAGE_KEY } from '../../constants/promotion';
import { clearCarriedOffer, readCarriedOffer, saveCarriedOffer } from '../../utils/carriedOffer';
const notifyChange = () => {
  const changeEvent = new Event(CARRIED_OFFER_STORAGE_KEY);
  window.dispatchEvent(changeEvent);
};
const useCarriedOffer = () => {
  const [carriedOffer, setCarriedOffer] = useState(readCarriedOffer);
  useEffectOnce(() => {
    const refresh = () => setCarriedOffer(readCarriedOffer());
    const onStorage = event => {
      if (event.key === null || event.key === CARRIED_OFFER_STORAGE_KEY) {
        refresh();
      }
    };
    window.addEventListener(CARRIED_OFFER_STORAGE_KEY, refresh);
    window.addEventListener('storage', onStorage);
    refresh();
    return () => {
      window.removeEventListener(CARRIED_OFFER_STORAGE_KEY, refresh);
      window.removeEventListener('storage', onStorage);
    };
  });
  const save = useCallback(code => {
    saveCarriedOffer(code);
    notifyChange();
  }, []);
  const clear = useCallback(() => {
    clearCarriedOffer();
    notifyChange();
  }, []);
  return useMemo(() => {
    return {
      carriedOffer,
      saveCarriedOffer: save,
      clearCarriedOffer: clear
    };
  }, [carriedOffer, clear, save]);
};
export default useCarriedOffer;